import { render } from "./LoadingIcon.vue?vue&type=template&id=1a590720&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"

import "./LoadingIcon.vue?vue&type=style&index=0&id=1a590720&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a590720"

export default script